var React = require('react');

function ManIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23.8432 25V22.6667C23.8432 21.429 23.3659 20.242 22.5164 19.3668C21.6668 18.4917 20.5145 18 19.3131 18H10.2528C9.05133 18 7.89907 18.4917 7.0495 19.3668C6.19994 20.242 5.72266 21.429 5.72266 22.6667V25","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M14.7821 13.3333C17.284 13.3333 19.3122 11.244 19.3122 8.66666C19.3122 6.08934 17.284 4 14.7821 4C12.2802 4 10.252 6.08934 10.252 8.66666C10.252 11.244 12.2802 13.3333 14.7821 13.3333Z","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ManIcon.defaultProps = {"width":"29","height":"28","viewBox":"0 0 29 28","fill":"none"};

module.exports = ManIcon;

ManIcon.default = ManIcon;
